// MuteButton.jsx
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import AudioOnIcon from '../../img/icon-audio-fill-shadow.svg';
import AudioOffIcon from '../../img/icon-mute-fill-shadow.svg';

export const MuteButton = ({ isMuted, setMute, children }) => {
  const handleOnClick = useCallback(() => {
    setMute(!isMuted);
  }, [isMuted, setMute]);

  return children({
    isMuted,
    handleOnClick,
    iconSource: isMuted ? AudioOffIcon : AudioOnIcon,
  });
};

MuteButton.propTypes = {
  isMuted: PropTypes.bool,
  showLargeIcon: PropTypes.bool,
  setMute: PropTypes.func,
  children: PropTypes.func,
};

MuteButton.defaultProps = {
  isMuted: false,
  showLargeIcon: false,
  setMute: () => null,
  children: () => null,
};

export default MuteButton;
